module.exports = "label{\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n}\r\n\r\n.card{\r\n  width: 65%;\r\n}\r\n\r\n.mask{\r\n  padding: 50px;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n\r\n  .mask{\r\n    padding: 10px;\r\n  }\r\n\r\n  .card{\r\n    width: 100%;\r\n  }\r\n\r\n}\r\n\r\n@media (min-width: 576px) and (max-width: 768px) {\r\n  .mask{\r\n    padding: 10px;\r\n  }\r\n\r\n  .card{\r\n    width: 100%;\r\n  }\r\n\r\n\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/nuevo-producto/nuevo-producto.component.css
// module id = ./src/app/componentes/nuevo-producto/nuevo-producto.component.css
// module chunks = main